/**
 * Extrai CID do IPFS de uma URL do Pinata ou gateway IPFS
 * @param {string} url - URL do IPFS (Pinata gateway, ipfs://, etc)
 * @returns {string|null} - CID extraído ou null se não for URL IPFS
 */
export const extractIPFSCID = (url) => {
  if (!url || typeof url !== 'string') return null;

  // Padrão Pinata: https://gateway.mypinata.cloud/ipfs/QmXyZ...
  // ou: https://turquoise-faithful-tick-357.mypinata.cloud/ipfs/QmXyZ...
  const pinataMatch = url.match(/\/ipfs\/([a-zA-Z0-9]{46,})/);
  if (pinataMatch) {
    return pinataMatch[1];
  }

  // Padrão ipfs://
  const ipfsProtocolMatch = url.match(/^ipfs:\/\/([a-zA-Z0-9]{46,})/);
  if (ipfsProtocolMatch) {
    return ipfsProtocolMatch[1];
  }

  // Padrão gateway genérico: https://ipfs.io/ipfs/QmXyZ...
  const genericMatch = url.match(/\/ipfs\/([a-zA-Z0-9]{46,})/);
  if (genericMatch) {
    return genericMatch[1];
  }

  return null;
};

/**
 * Verifica se uma URL é do IPFS (Pinata ou gateway genérico)
 * @param {string} url - URL para verificar
 * @returns {boolean}
 */
export const isIPFSURL = (url) => {
  if (!url) return false;
  return /\/ipfs\//.test(url) || url.startsWith('ipfs://');
};

